import { vueAppWithPinia } from "../Common/vueApp";
import FederationsListingApp from "./FederationsListingApp.vue";

export default vueAppWithPinia(FederationsListingApp);
